import dayjs from "dayjs"

export const leadEstimateInitial = {
    "quoteTotal": null,
    "costTotal": null,
    "quoteExpiresOn": dayjs().add(3, "months").toISOString(),
    "notes": "",
    "vatIncluded": false,
    "materialPriceChargeable": false,
    "services": ["Removal", "Full Pack", /*"Extra"*/].map((ele, index) => (
        {
            "typeName": ele,
            "description": `${ele ==='Removal' ? 'Removal Door To Door' : ele + ' Service'} `,
            "type": '',
            "price": null,
            "isAccepted":ele === "Removal"? true : false,
            "driverQty": null,
            "porterQty": null,
            "packerQty": null,
            "vehicles": [
                {
                    "vehicleQty": null,
                    "vehicleTypeId": "",
                    "fuelCharge": null,
                }
            ],
            "wageCharge": null,
            "orderIndex" : index + 1,
        }
    )),
    "materials": [
        "Packing Materials",
        // "Fragile Boxes",
        // "Medium Boxesm457x305x305",
        // "Large Boxes 457x457x457",
        // "Bubble Wrap 300x75m roll",
        // "Packing Tape (professional/easy tear)",
        // "Tissue Paper (5 Kilo Packets)",
        // "Wardrobe Cartoons",
        // "Delivery Charge",
        // "Lay-Flat Clothes Box"
    ].map(ele => (
        {
            "name": ele,
            "surveyedQty": 0,
            "chargeQty": 0,
            "price": 0,
            "total": 0,
            "volume": 0,
            "cost": 0
        }
    )),
   
    "generalInfo":
        {
            "driverWage": null,
            "porterWage": null,
            "packerWage": null,
            // "contentsValue": null,
        },
    "paymentMethod": "",
    "contentValue":null,
    "insuranceAmount": null,
    "insurancePercentage": null,
    "insuranceType": "",
    "ancillaries": ["Tolls", "Ferry charges", ""].map(ele => (
        {
            "name": ele,
            "charge": null,
            "isChargeable": false
        }
    )),
    "subcontractorCharges": [
        {
            "subContractorId": "",
            "name": "",
            "chargeAmount": null,
            // "isChargeable": false
        }
    ]
}


export const leadEstimateKeysRoot = {
    "estimate_id": "estimateId",
    "lead_id": "leadId",
    "quote_total": "quoteTotal",
    "cost_total": "costTotal",
    "quote_expires_on": "quoteExpiresOn",
    "notes": "notes",
    "vat_included": "vatIncluded",
    "material_price_chargeable": "materialPriceChargeable",
    "services": "services",
    "materials": "materials",
    // "costs": "costs",
    // "general_info": "generalInfo",
    "ancillaries": "ancillaries"
}

export const leadEstimateKeysServices = {
    "service_id": "serviceId",
    "service_name": "serviceName",
    "service_description": "serviceDescription",
    "service_price": "servicePrice",
    "driver_qty": "driverQty",
    "porter_qty": "porterQty",
    "packer_qty": "packerQty",
    "vehicle_qty": "vehicleQty",
    "vehicle_type_id": "vehicleTypeId",
    "fuel_qty": "fuelQty",
    "fuel_charge": "fuelCharge"
}

export const leadEstimateKeysCosts = {
    "cost_id": "costId",
    "driver_qty": "driverQty",
    "porter_qty": "porterQty",
    "packer_qty": "packerQty",
    "vehicle_qty": "vehicleQty",
    "vehicle_type_id": "vehicleTypeId",
    "fuel_qty": "fuelQty",
    "fuel_charge": "fuelCharge"
}

export const leadEstimateKeysMaterials = {
    "material_id": "materialId",
    "material_name": "materialName",
    "material_dimensions": "materialDimensions",
    "surveyed_qty": "surveyedQty",
    "charge_qty": "chargeQty",
    "material_price": "materialPrice",
    "material_total": "materialTotal",
    "material_volume": "materialVolume",
    "material_cost": "materialCost"
}

export const leadEstimateKeysGeneralInfo = {
    "general_info_id": "generalInfoId",
    "driver_wage": "driverWage",
    "porter_wage": "porterWage",
    "packer_wage": "packerWage",
    "contents_value": "contentsValue",
    "payment_method": "paymentMethod",
    "insurance_amount": "insuranceAmount",
    "insurance_percentage": "insurancePercentage",
    "insurance_type": "insuranceType"
}

export const leadEstimateKeysAncillaries = {
    "ancillary_id": "ancillaryId",
    "ancillary_name": "ancillaryName",
    "ancillary_charge": "ancillaryCharge",
    "ancillary_is_chargeable": "ancillaryIsChargeable"
}


// new quote screen
export const leadQuoteInitial = {
    "quoteTotal": null,
    "costTotal": null,
    "quoteExpiresOn": dayjs().add(3, "months").toISOString(),
    "notes": "",
    "transportnote": "",
    "quotenote": "",
    "vatIncluded": false,
    "materialPriceChargeable": false,
    "accepted_status": "Initiated",
    "services": ["Removal", "Full Pack", /*"Extra"*/].map((ele, index) => (
        {
            "typeName": ele,
            "description": `${ele ==='Removal' ? 'Removal Door To Door' : ele + ' Service'} `,
            "price": null,
            "isAccepted":ele === "Removal"? true : false,
            "day": index === 0 ? 1 : null,
            "provisionalDate": null,
            "driverQty": null,
            "porterQty": null,
            "packerQty": null,
            "vehicles": [
                {
                    "vehicleQty": null,
                    "vehicleTypeId": "",
                    "fuelCharge": null,
                }
            ],
            // "vehicleQty": null,
            // "vehicleTypeId": "",
            "wageCharge": null,
            // "fuelCharge": null,
            "orderIndex" : index + 1,
        }
    )),
    "materials": [
        "Packing Materials",
        // "Fragile Boxes",
        // "Medium Boxesm457x305x305",
        // "Large Boxes 457x457x457",
        // "Bubble Wrap 300x75m roll",
        // "Packing Tape (professional/easy tear)",
        // "Tissue Paper (5 Kilo Packets)",
        // "Wardrobe Cartoons",
        // "Delivery Charge",
        // "Lay-Flat Clothes Box"
    ].map(ele => (
        {
            "name": ele,
            "surveyedQty": 0,
            "chargeQty": 0,
            "price": 0,
            "total": 0,
            "volume": 0,
            "cost": 0
        }
    )),
   
    "generalInfo":
        {
            "driverWage": null,
            "porterWage": null,
            "packerWage": null,
            // "contentsValue": null,
        },
    "paymentMethod": "",
    "payment_method_id": null,
    "contentValue":null,
    "insuranceAmount": null,
    "insurancePercentage": null,
    "insuranceType": "Goods value",
    "insurance_type_id": null,
    "ancillaries": ["Tolls", "Ferry charges", ""].map(ele => (
        {
            "name": ele,
            "charge": null,
            "isChargeable": false
        }
    )),
    "subcontractorCharges": [
        {
            "subContractorId": "",
            "name": "",
            "chargeAmount": null,
            // "isChargeable": false
        }
    ]
}


export const leadQuoteKeysRoot = {
    "estimate_id": "estimateId",
    "lead_id": "leadId",
    "quote_total": "quoteTotal",
    "cost_total": "costTotal",
    "quote_expires_on": "quoteExpiresOn",
    "notes": "notes",
    "vat_included": "vatIncluded",
    "material_price_chargeable": "materialPriceChargeable",
    "services": "services",
    "materials": "materials",
    // "costs": "costs",
    // "general_info": "generalInfo",
    "ancillaries": "ancillaries",
    "subcontractor": "subcontractor"
}

export const leadQuoteKeysServices = {
    "service_id": "serviceId",
    "service_name": "serviceName",
    "service_description": "serviceDescription",
    "service_price": "servicePrice",
    "driver_qty": "driverQty",
    "porter_qty": "porterQty",
    "packer_qty": "packerQty",
    "vehicle_qty": "vehicleQty",
    "vehicle_type_id": "vehicleTypeId",
    "fuel_qty": "fuelQty",
    "fuel_charge": "fuelCharge"
}

export const leadQuoteKeysCosts = {
    "cost_id": "costId",
    "driver_qty": "driverQty",
    "porter_qty": "porterQty",
    "packer_qty": "packerQty",
    "vehicle_qty": "vehicleQty",
    "vehicle_type_id": "vehicleTypeId",
    "fuel_qty": "fuelQty",
    "fuel_charge": "fuelCharge"
}

export const leadQuoteKeysMaterials = {
    "material_id": "materialId",
    "material_name": "materialName",
    "material_dimensions": "materialDimensions",
    "surveyed_qty": "surveyedQty",
    "charge_qty": "chargeQty",
    "material_price": "materialPrice",
    "material_total": "materialTotal",
    "material_volume": "materialVolume",
    "material_cost": "materialCost"
}

export const leadQuoteKeysGeneralInfo = {
    "general_info_id": "generalInfoId",
    "driver_wage": "driverWage",
    "porter_wage": "porterWage",
    "packer_wage": "packerWage",
    "contents_value": "contentsValue",
    "payment_method": "paymentMethod",
    "insurance_amount": "insuranceAmount",
    "insurance_percentage": "insurancePercentage",
    "insurance_type": "insuranceType"
}

export const leadQuoteKeysAncillaries = {
    "ancillary_id": "ancillaryId",
    "ancillary_name": "ancillaryName",
    "ancillary_charge": "ancillaryCharge",
    "ancillary_is_chargeable": "ancillaryIsChargeable"
}

export const leadQuoteKeysSubcontractor = {
    "subcontractor_id": "subcontractorId",
    "subcontractor_name": "subcontractorName",
    "subcontractor_charge": "subcontractorCharge",
    // "subcontractor_is_chargeable": "subcontractorIsChargeable"
}